export enum POSConfigErrors {
  BadResponse = "Bad response",
  NoTicketGroups = "No ticket groups in pos config",
  MissingRequiredFields = "Required pos config fields missing",
  NoPOSConfigSelected = "No POSConfig selected",
  NoTerminal = "No terminal is selected",
}
